import './skeleton-programs.scss';
import Skeleton from '@mui/material/Skeleton';
import Grid from '@mui/material/Grid';

export const SkeletonPrograms = () => {

    return (
        <div className='skeleton-programs'>
            <Grid container className='skeleton-cards-programs' justifyContent={'center'} spacing={4}>
                <Grid item xs={3} className='card-skeleton-programs'>
                    <Skeleton variant="rectangular" height={300}/>
                </Grid>
                <Grid item xs={3} className='card-skeleton-programs'>
                    <Skeleton variant="rectangular" height={300}/>
                </Grid>
                <Grid item xs={3} className='card-skeleton-programs'>
                    <Skeleton variant="rectangular" height={300}/>
                </Grid>
            </Grid>
        </div >
    );
}